import { render, staticRenderFns } from "./serviceitem.vue?vue&type=template&id=1dfbcba2&scoped=true"
import script from "./serviceitem.vue?vue&type=script&lang=js"
export * from "./serviceitem.vue?vue&type=script&lang=js"
import style0 from "./serviceitem.vue?vue&type=style&index=0&id=1dfbcba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfbcba2",
  null
  
)

export default component.exports